<template>
  <div class="properties-centent kk-checkbox">
    <div class="properties-body">
      <a-empty
        class="hint-box"
        v-show="selectItem.key === ''"
        description="未选择控件"
      />

      <a-form v-show="selectItem.key !== '' ">
        <a-form-item v-if="isDefined(selectItem.label) || selectItem.componentKey !='customization.result'" label="标签">
          <el-input
            type="textarea"
            autosize
            v-model="selectItem.componentName"
            placeholder="请输入"
          />
        </a-form-item>

        <template v-if="selectItem.componentKey === 'customization.time'">
          <a-form-item label="培养时间类型">

           <el-select  v-model="selectItem.options.timeType" placeholder="请选择">
              <el-option
                v-for="item in dict.TEMPLATE_TIME_TYPE"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select>
          </a-form-item>

          <a-form-item label="格式化方式"
            v-if="selectItem.options.timeType === '1'"
          >

            <el-select  v-model="selectItem.options.timeFormat" placeholder="请选择">
              <el-option
                v-for="item in dict.TEMPLATE_TIME_FORMAT"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select>
          </a-form-item>
        </template>

        <template v-if="selectItem.componentKey === 'customization.temperature'">
          <a-form-item label="培养温度类型">
            <el-select  v-model="selectItem.options.temperatureType" placeholder="请选择">
               <el-option
                 v-for="item in dict.TEMPLATE_TEMPERATURE_TYPE"
                 :key="item.dictValue"
                 :label="item.dictLabel"
                 :value="item.dictValue"
               />
             </el-select>
          </a-form-item>
        </template>

        <template v-if="selectItem.componentKey === 'customization.fix'">
          <a-form-item label="请输入固定显示值">
            <Textarea
              v-model="selectItem.fixValue"
              :autoSize="{ minRows: 4, maxRows: 8 }"
            />
          </a-form-item>
        </template>

        <template v-if="selectItem.componentKey === 'customization.firstResult'">
          <a-form-item label="是否显示培养时间">
           <el-radio-group v-model="selectItem.options.isTime" style="width: 158px">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </a-form-item>
        


         <a-form-item label="培养时间类型"  v-if="selectItem.options.isTime === '1'">
           <el-select  v-model="selectItem.options.timeType" placeholder="请选择">
              <el-option
                v-for="item in dict.TEMPLATE_TIME_TYPE"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select>
          </a-form-item>

          <a-form-item label="格式化方式"
            v-if="selectItem.options.timeType === '1'"
          >

            <el-select  v-model="selectItem.options.timeFormat" placeholder="请选择">
              <el-option
                v-for="item in dict.TEMPLATE_TIME_FORMAT"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select>
          </a-form-item>




          <a-form-item label="是否显示培养温度">
            <el-radio-group v-model="selectItem.options.isTemperature" style="width: 158px">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </a-form-item>



          <a-form-item label="培养温度类型"
            v-if="selectItem.options.isTemperature === '1'"
          >
            <el-select  v-model="selectItem.options.temperatureType" placeholder="请选择">
               <el-option
                 v-for="item in dict.TEMPLATE_TEMPERATURE_TYPE"
                 :key="item.dictValue"
                 :label="item.dictLabel"
                 :value="item.dictValue"
               />
             </el-select>
          </a-form-item>
        </template>
        
        <template v-if="selectItem.componentKey === 'customization.result'">
          <a-form-item label="配置结果集表头">
          <el-button type="primary" @click="handleEditResult">编辑结果数据</el-button>
           </a-form-item>
        </template>

              
        <template v-if="selectItem.componentKey === 'customization.count'">
          <a-form-item label="配置计算公式">
          <el-button type="primary">编辑计算公式</el-button>
           </a-form-item>
        </template>

      </a-form>
    </div>
    <el-dialog
      title="结果集配置"
      :visible.sync="dialogVisible"
      width="80%"
      height="200px"
      :before-close="handleClose"
    >
      <TreeTest ref="Tree" :Item="selectItem"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="tableAdd()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/*
 * author kcz
 * date 2019-11-20
 * description 表单控件属性设置组件,因为配置数据是引用关系，所以可以直接修改
 */
import KChangeOption from "../../KChangeOption/index.vue";
import kCheckbox from "../../KCheckbox/index.vue";
import { pluginManager } from "../../../utils/index";
const Input = pluginManager.getComponent("input").component;
const InputNumber = pluginManager.getComponent("number").component;
const Rate = pluginManager.getComponent("rate").component;
const Checkbox = pluginManager.getComponent("checkbox").component;
const Radio = pluginManager.getComponent("radio").component;
const RadioButton = pluginManager.getComponent("radioButton").component;
const RadioItem = pluginManager.getComponent("radioItem").component;
const Textarea = pluginManager.getComponent("textarea").component;
const Select = pluginManager.getComponent("select").component;
const ColorPicker = pluginManager.getComponent("colorPicker").component;
const ASwitch = pluginManager.getComponent("switch").component;
import TreeTest from "./tree.vue";
import JsMind from '../../../../../../components/Jsmind/Jsmind.vue'
// ../../../components/Jsmind/Jsmind.vue
export default {
  name: "formItemProperties",
  components: {
    KChangeOption,
    kCheckbox,
    ColorPicker,
    Input,
    InputNumber,
    Rate,
    ASwitch,
    Checkbox,
    Radio,
    RadioItem,
    RadioButton,
    Textarea,
    Select,
    TreeTest,
    JsMind
  },
  dicts: ['TEMPLATE_TIME_TYPE','TEMPLATE_TIME_FORMAT','TEMPLATE_TEMPERATURE_TYPE'],
  data() {
    return {
      dialogVisible: false,
      familyOptions: [
        // 字体选择设置
        {
          value: "",
          label: "默认",
        },
        {
          value: "SimSun",
          label: "宋体",
        },
        {
          value: "FangSong",
          label: "仿宋",
        },
        {
          value: "SimHei",
          label: "黑体",
        },
        {
          value: "PingFangSC-Regular",
          label: "苹方",
        },
        {
          value: "KaiTi",
          label: "楷体",
        },
        {
          value: "LiSu",
          label: "隶书",
        },
      ],
      sizeOptions: [
        //字号选择设置
        {
          value: "26pt",
          label: "一号",
        },
        {
          value: "24pt",
          label: "小一",
        },
        {
          value: "22pt",
          label: "二号",
        },
        {
          value: "18pt",
          label: "小二",
        },
        {
          value: "16pt",
          label: "三号",
        },
        {
          value: "15pt",
          label: "小三",
        },
        {
          value: "14pt",
          label: "四号",
        },
        {
          value: "12pt",
          label: "小四",
        },
        {
          value: "10.5pt",
          label: "五号",
        },
        {
          value: "9pt",
          label: "小五",
        },
      ],
    };
  },
  computed: {
    options() {
      return this.selectItem.options || {};
    },
  },
  props: {
    selectItem: {
      type: Object,
      required: true,
    },
    hideModel: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    console.log(this.option, "optionoption");
    console.log(this.selectItem, "==============================>");
  },
  methods: {
       tableAdd() {
        // { ...this.$refs.Tree.treeData };
        const treeDataCopy =JSON.parse(JSON.stringify(this.$refs.Tree.treeData));
        console.log(treeDataCopy, "====treeDataCopy=========>");
      this.selectItem.children = treeDataCopy
      this.dialogVisible = false;
      // this.$forceUpdate()
      console.log(this.selectItem, "====selectItem=========>");
    },
    handleEditResult(){
      this.dialogVisible = true;
       console.log('编辑结果集',this.selectItem);
    },
    handleClose(){
      this.dialogVisible = false;
    },
    /**
     * 判断是否已定义
     * @param {*} value
     */
    isDefined(value) {
      return typeof value !== "undefined";
    },
  },
};
</script>
